import React, { useCallback } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { bool, func, shape, string } from "prop-types";

import Image from "pages/_components/Image";
import TokenRandomCode from "pages/settings/TokenRandomCode";

import * as i18n from "util/i18n";

const HEADER_BG = "#0a2856";
const HEADER_TEXT_COLOR = "#FFFFFF";

function TokenRandomCodeV3Wrapper({ dispatch, history, isDesktop, location, match, ...rest }) {
    const handleBack = useCallback(() => {
        if (history && typeof history.push === "function") {
            history.push("/v3/login");
        } else {
            dispatch(push("/v3/login"));
        }
    }, [dispatch, history]);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                minHeight: "100vh",
                backgroundColor: "#FFFFFF",
            }}>
            <div
                style={{
                    position: "relative",
                    backgroundColor: HEADER_BG,
                    color: HEADER_TEXT_COLOR,
                    width: "100%",
                    minHeight: "calc(4.5rem + env(safe-area-inset-top))",
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "center",
                    paddingTop: "calc(env(safe-area-inset-top) + 12px)",
                    paddingBottom: 16,
                    paddingLeft: 16,
                    paddingRight: 16,
                    boxSizing: "border-box",
                }}>
                <button
                    type="button"
                    onClick={handleBack}
                    aria-label={i18n.get("global.back")}
                    style={{
                        position: "absolute",
                        left: 8,
                        bottom: 12,
                        background: "transparent",
                        border: 0,
                        padding: 8,
                        cursor: "pointer",
                        color: HEADER_TEXT_COLOR,
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}>
                    <Image
                        src="images/arrowLeft.svg"
                        className="svg-image"
                        styles={{ filter: "brightness(0) invert(1)", width: 24, height: 24 }}
                    />
                </button>
                <span style={{ fontSize: 18, fontWeight: 700, color: HEADER_TEXT_COLOR, lineHeight: "24px" }}>
                    {i18n.get("settings.tokenPassword")}
                </span>
            </div>

            <div style={{ flex: 1, display: "flex", flexDirection: "column", width: "100%", padding: "16px 0" }}>
                <TokenRandomCode
                    {...rest}
                    history={history}
                    location={location}
                    match={match}
                    isDesktop={isDesktop}
                    propsGrid={{ showLogoState: false, pathname: location?.pathname || "" }}
                    embeddedInV3Shell
                />
            </div>
        </div>
    );
}

TokenRandomCodeV3Wrapper.propTypes = {
    dispatch: func.isRequired,
    history: shape({ push: func }),
    location: shape({ pathname: string }),
    match: shape({}),
    isDesktop: bool,
};

TokenRandomCodeV3Wrapper.defaultProps = {
    history: null,
    location: null,
    match: null,
    isDesktop: false,
};

export default connect()(TokenRandomCodeV3Wrapper);
